import BlockOption from './shared/block-options'

$ ->
  initBlockOptions = (elements) ->
    $(elements).each (i, element) ->
      mode = if $(element).find('.block-option-field').attr('type') == 'radio' then 'single' else 'multiple'
      blockOption = new BlockOption
                      element: element
                      mode: mode

  initBlockOptions($('.block-option'))
  tower.stack.on 'pageload', (e, $page, page) ->
    initBlockOptions($page.find('.block-option'))

  $(document).on 'click', '.block-option', (e) ->
    $blockOption = $(e.currentTarget)
    blockOption = $blockOption.data('block-option')

    if !blockOption.selected
      blockOption.active()
    else if !blockOption.required
      blockOption.inactive()
